export const qs = (
	selector: string,
	parent: HTMLElement | Document = document
) => {
	return parent.querySelector(selector);
};

export const qsa = (
	selector: string,
	parent: HTMLElement | Document = document
) => {
	return parent.querySelectorAll(selector);
};

export const siblings = function (elem: HTMLElement) {
	// Setup siblings array and get the first sibling
	var siblings = [];
	var sibling = elem.parentNode.firstChild;

	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}

	return siblings;
};
